import { IWhatsappApi } from "../base/externalServices/whatsappAPI";

const baseRoute: string = "https://api.whatsapp.com";

export class WhatsappApi extends IWhatsappApi {
	sendMessage(phone: string, message: string): void {
		window.open(`${baseRoute}/send?phone=${phone}&text=${message}`);
	}
}
